import React from 'react'
import MailOutlineIcon from '@mui/icons-material/MailOutline'
import TelegramIcon from '@mui/icons-material/Telegram'
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline'
import Tooltip from '@mui/material/Tooltip'
import type { SvgIconProps } from '@mui/material/SvgIcon'

export interface PlatformIconProps {
  platform: string
  fontSize?: SvgIconProps['fontSize']
  sx?: SvgIconProps['sx']
}

export function PlatformIcon({ platform, ...props }: PlatformIconProps) {
  const normalized = (platform || '').toLowerCase()

  switch (normalized) {
    case 'email':
      return <MailOutlineIcon {...props} />
    case 'telegram':
      return (
        <Tooltip title="Telegram" arrow placement="top">
          <span style={{ display: 'inline-flex' }}>
            <TelegramIcon {...props} />
          </span>
        </Tooltip>
      )
    case 'whatsapp':
      return (
        <Tooltip title="WhatsApp" arrow placement="top">
          <span style={{ display: 'inline-flex' }}>
            <ChatBubbleOutlineIcon {...props} />
          </span>
        </Tooltip>
      )
    default:
      return <ChatBubbleOutlineIcon {...props} />
  }
}

export default PlatformIcon
